// extracted by mini-css-extract-plugin
module.exports = {"highlighted-discount":"_2GR1WBu","highlightedDiscount":"_2GR1WBu"};